const users = {
  users: 'Utilisateurs',
  first_name: 'Prénom',
  last_name: 'Nom de famille',
  login: 'Connexion',
  edit_user: 'Utilisateur',
  user_details: "Détails de l'utilisateur",
  add_new_user_modal_title: 'Ajouter un nouvel utilisateur',
  user_created_successfully: 'Utilisateur créé avec succès',
  could_not_create_user: "Impossible de créer l'utilisateur",
  search_user: 'Rechercher un utilisateur',
  display_events: 'Afficher les événements',
  select_at_least_one_user_to_view_events:
    'Sélectionnez au moins un utilisateur pour voir les événements',
  max_selection_reached:
    'Vous pouvez sélectionner un maximum de {{ count }} utilisateurs',
  delete_user_message:
    "Etes-vous sûr que vous voulez supprimer {{user}} <br> Si l'utilisateur a des identifiants associés, ceux-ci seront également dissociés.",
  delete_morethan_one_site:
    "REMARQUE: Cet utilisateur est associé à plus d'un site, il sera supprimé de tous.",
  confirm_modal_confirm: 'Oui, supprimer',
  remove_login: 'Supprimer la Connexion',
  remove_confirmation_msg:
    "Êtes-vous sûr de vouloir supprimer l'accès web de l'utilisateur?",
  activate_confirm_msg:
    'Êtes-vous sûr de vouloir {{action}} {{user}} sur le compte {{account}}?',
  access_levels: "Niveaux d'accès",
  no_custom_fields: "Aucun champ personnalisé n'est configuré pour ce site.",
  general_information: 'Informations générales',
  custom_fields: 'Champs personnalisés',
  custom_fields_success: 'Champs personnalisés enregistrés avec succès',
  custom_field_type_single_line_string: 'Champ de texte',
  custom_field_type_numeric: 'Numérique',
  custom_field_type_date: 'Date',
  custom_field_type_email: 'Courriel',
  custom_field_type_checkbox: 'Case à cocher',
  custom_field_type_true_or_false: 'Vrai ou faux',
  unassign_site_credentials_note:
    'Dissocier l’utilisateur de ce site entraînera la dissociation de ses éventuels identifiants.',
  unassign_site_last_site_note:
    "Cela entraînera également la suppression de l'utilisateur de ce compte.",
  access_rights: "Droits d'accès",
  table: {
    first_name: 'PRENOM',
    last_name: 'NOM DE FAMILLE',
    email: 'COURRIEL',
    user: 'UTILISATEUR',
    role: 'RÔLE',
    phone: 'TÉLÉPHONER',
    last_login: 'DERNIÈRE CONNEXION',
    status: 'STATUT',
  },
  form: {
    username: "Nom d'utilisateur",
    email: 'Courriel',
    phone_number: 'Numéro de téléphone',
    date_created: 'Date de création',
    date_updated: 'Date de mise à jour',
    new_password: 'Nouveau mot de passe',
    role: 'Rôle',
    select_role: 'Sélectionner un rôle',
    no_role: 'Aucun rôle',
    define_email:
      'Définissez une adresse courriel pour cet utilisateur avant de lui attribuer un rôle.',
    set_as_admin: 'Définir comme {{role}}',
  },
  profile: {
    actions: 'Actions',
    role_details: 'Détails des rôles',
    company_organization: 'Entreprise/Organisation',
    remove_from_company_confirm:
      'Êtes-vous sûr de vouloir retirer {{name}} de {{company}}? Important : cette action est irréversible.',
    change_role_confirm:
      'Êtes-vous sûr de vouloir changer le rôle de {{name}} de {{prevRole}} à {{currentRole}}? Important : cette action est irréversible.',
    roles_table_aria_label: 'Tableau des rôles utilisateurs et des entreprises',
    location: 'Emplacements',
    device: 'Dispositif',
    ip_address: 'adresse IP',
    date_time: 'Date/heure',
    profile: 'Détails du profil',
    update: 'Mise à jour',
    activities: 'Activités',
    change: 'Changer',
    user_updated: 'Le profil utilisateur a été mis à jour',
    user_updated_success: 'Utilisateur mis à jour avec succès',
    could_not_update_user: "Impossible de mettre à jour l'utilisateur",
    profile_deleted: 'Profil utilisateur supprimé',
    could_not_delete_profile: 'Impossible de supprimer le profil utilisateur',
    role_updated: 'Rôle mis à jour',
    could_not_update_role: 'Impossible de mettre à jour le rôle',
    allowed_filetypes: 'types de fichiers autorisés: png, jpg, jpeg.',
    avatar_modal_description: 'Voulez-vous vraiment supprimer votre avatar?',
    login_sessions: 'Sessions de connexion',
  },
  add: {
    country: 'Pays',
    city: 'Ville',
    address: 'Adresse',
    phone: 'Téléphone',
    email: 'Courriel',
    assign_card: 'Attribuer un identifiant',
    none: 'Aucun',
    first_registration: 'Première inscription',
    coming_from_another_site: "Venant d'un autre site",
    user_found: 'Utilisateur trouvé !',
    no_user_found:
      "Aucun utilisateur n'a été trouvé associé à cette carte, veuillez utiliser une autre carte.",
    use_this_user: 'Utiliser cet utilisateur',
    no_reader: 'Aucun lecteur',
  },
  security: {
    allow_extend_time: 'Autoriser le temps de prolongation',
    allow_antipassback_override: 'Autoriser la dérogation anti-retour',
    activation_date: "Date d'activation",
    expiration_date: "Date d'expiration",
    generate_keypad_code: 'Générer un nouveau code clavier',
    all: 'Tout',
  },
  card: {
    assign_a_card: 'Attribuer un identifiant',
    assign: 'Attribuer',
    to: 'à',
    format: 'Format',
    card_number: "Numéro de l'identifiant",
    assign_card_confirm:
      "Voulez-vous attribuer l'identifiant {{number}} à {{username}}?",
    confirm_btn: 'Confirmer',
    display_name: "Nom d'affichage",
  },
  delete: {
    success: "L'utilisateur {{name}} a été supprimé avec succès",
    error: 'Impossible de supprimer',
  },
  error: {
    invalid_email: "Format d'adresse courriel invalide",
    invalid_date: 'Format de date invalide',
  },
  events: {
    tabTitle: 'Événements',
  },
};

export default users;
